/**
 * Modo "solo invitacion" (opt-in, build-time).
 * Solo `VITE_INVITE_ONLY=true` lo activa; cualquier otro valor o ausencia
 * deja el registro publico como siempre.
 */
export function parseInviteOnly(value: unknown): boolean {
  return typeof value === 'string' && value.trim().toLowerCase() === 'true'
}

export const INVITE_ONLY = parseInviteOnly(import.meta.env.VITE_INVITE_ONLY)
